import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="square-behind-square-1, copy 1, layers, pages" maskId="round-filled-radius-0-stroke-1.5-IconSquareBehindSquare1"><path fillRule="evenodd" clipRule="evenodd" d="M2 2.75C2 2.33579 2.33579 2 2.75 2H15.25C15.6642 2 16 2.33579 16 2.75V8H21.25C21.6642 8 22 8.33579 22 8.75V21.25C22 21.6642 21.6642 22 21.25 22H8.75C8.33579 22 8 21.6642 8 21.25V16H2.75C2.33579 16 2 15.6642 2 15.25V2.75ZM14.5 8H8.75C8.33579 8 8 8.33579 8 8.75V14.5H3.5V3.5H14.5V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
